//-- Copyright (c) 2021 TMT Insights Group, LLC
import { Grid, Typography } from '@mui/material';
import { JobDetail } from '@/redux/slices/slice_types';
import { StatusColors } from '@/constants/constants';
import { ClickCopy, CSVLanguages, JobsEmbargoDate, JobTypeLabel, Notes, TableJobStage, UserDisplay } from '@/exports/columnCommonComponents';
import { titleCase } from '@/_utils/utils';

export default {
  hid: {
    label: 'Job ID',
    sortField: 'id',
    minWidth: 75,
    render: (cell: JobDetail['hid']) => (
      <ClickCopy copyText={cell} noBackground disableTextClick>
        <Typography variant="subtitle1">{cell}</Typography>
      </ClickCopy>
    )
  },
  job_type: {
    label: 'Job Type',
    render: (cell: JobDetail['job_type']) => <JobTypeLabel type={cell} />
  },
  component_type: {
    label: 'Component Type',
    disableSort: true,
    render: (cell: any, row: JobDetail) => (row.assets?.components?.length ? titleCase(row.assets.components[0].type) : '-')
  },
  sub_type: {
    label: 'Sub Type',
    disableSort: true,
    render: (cell: any, row: JobDetail) => (row.assets?.components?.length ? titleCase(row.assets.components[0].sub_type) : '-')
  },
  language: {
    label: 'Language',
    disableSort: true,
    render: (cell: any, row: JobDetail) =>
      row.assets?.components?.length ? <CSVLanguages codes={row.assets.components[0].lang ? [row.assets.components[0].lang] : []} type="all" /> : '-'
  },
  stage: {
    label: 'Status',
    render: (cell: JobDetail['stage'], row: JobDetail) => (
      <Grid container rowSpacing={1}>
        <Grid item xs={12}>
          <TableJobStage status={cell || row.status} colorOverride={StatusColors[row.status as keyof typeof StatusColors]} />
        </Grid>
        {row?.embargo_date && !row?.embargo_resumed_at && (
          <Grid item xs={12}>
            <JobsEmbargoDate job={row} />
          </Grid>
        )}
      </Grid>
    )
  },
  managed_by: {
    label: 'Managed By',
    disableSort: true,
    minWidth: 100,
    render: (cell: JobDetail['managed_by'], row: JobDetail) => (cell ? <UserDisplay user={cell} emptyText="-" /> : row.managed_by || '-')
  },
  notes: {
    label: 'Notes',
    minWidth: 70,
    render: (_cell: undefined, row: JobDetail) => (
      <div style={{ width: 40, textAlign: 'center' }}>
        <Notes data={row} type="jobs" />
      </div>
    ),
    disableSort: true
  }
};
